/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

import { useEffect, useState } from 'react';
import SignInForm from '@components/auth/sign-in-form';

export function GlobalAuthInterceptor() {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const handleIntercept = (e: Event) => {
            const customEvent = e as CustomEvent;
            setMessage(customEvent.detail?.message ?? 'Authorization refresh requested');
            setIsOpen(true);
        };

        window.addEventListener('auth-intercept', handleIntercept);
        return () => {
            window.removeEventListener('auth-intercept', handleIntercept);
        };
    }, []);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="animate-in fade-in fixed inset-0 z-100 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm duration-200">
            <div className="bg-theme-content-bg text-theme-text border-theme-border animate-in zoom-in-95 w-full max-w-md rounded-2xl border p-6 shadow-2xl duration-200 sm:p-8">
                <div className="mb-4 text-center">
                    <div className="bg-primary/10 text-primary mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full">
                        <span className="material-symbols-rounded text-2xl font-bold">lock_person</span>
                    </div>
                    <h2 className="mb-1 text-xl font-bold">Session Expired</h2>
                    <p className="text-theme-text-light text-sm">{message}</p>
                </div>

                <SignInForm
                    className="max-w-none"
                    inlineError={true}
                    showGreeting={false}
                    showRegisterLink={false}
                    showThirdParty={false}
                    showAgreement={false}
                    onAuthenticated={() => {
                        setIsOpen(false);
                        window.location.reload();
                    }}
                />
            </div>
        </div>
    );
}
